import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </Tag>
  );
};

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`hero-line ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionTag = ({ children }) => (
  <p className="text-xs font-mono uppercase tracking-[0.25em] text-golddeep font-medium">
    {children}
  </p>
);

export const Marquee = ({ items }) => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-gold/25 bg-cream py-5 select-none"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {items.map((item, i) => (
            <span
              key={`${copy}-${i}`}
              className="mx-8 flex items-center gap-8 font-serif text-lg italic text-slate-500"
            >
              {item}
              <span className="h-1.5 w-1.5 rotate-45 bg-gold inline-block" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
